/*
 * @Author: sunxiaohui
 */
import { clamp } from './index'
/*
    设置Transform
    例如：setTransform(this.$picker.style, `translate3d(0,${lastY}px,0)`)
*/
export const setTransform = (nodeStyle, value) => {
    nodeStyle.transform = value;
};

export const setTransition = (nodeStyle, value) => {
    nodeStyle.transition = value
}


export function touchAction(node, { defaultIndex, direction, autoplay, interval }) {
    let _len = node.childElementCount;
    const isHori = (direction === 'horizontal'); //是否水平
    const isTouch = "ontouchstart" in window;
    let dragable = false
    let index = defaultIndex
    //
    let initC = 0
    let moveC = 0
    let lastC = 0
    let itemSize = 0
    let disC = 0
    let safeC = 30
    let timer = null
    //
    function init() {
        node.style.width = "auto"
        node.style.height = "auto"
        setTimeout(() => {
            if (_len > 1) {
                const f = node.children[0]
                const l = node.children[_len - 1]
                f.insertAdjacentElement('beforebegin', l.cloneNode(true))
                l.insertAdjacentElement('afterend', f.cloneNode(true))
            } else if (_len === 1) {
                index = 0
            }
            _len = node.childElementCount;
            const { height, width } = node.children[0].getBoundingClientRect();
            node.style.width = `${width}px`
            node.style.height = `${height}px`
            itemSize = isHori ? width : height;
            safeC = isHori ? width * 0.3 : height * 0.3;
            console.log(safeC);
            lastC = (0 - index) * itemSize;
            const trans = isHori ? `translate3d(${(0 - index) * itemSize}px,0,0)` : `translate3d(0,${(0 - index) * itemSize}px,0)`
            setTransform(node.style, trans)
        }, 100)
    }
    //初始化
    setTimeout(init, 0);
    //
    function handleDown(event) {
        if (_len === 1) return
        dragable = true
        stop();

        const { clientX, clientY } = isTouch ? event.touches[0] : event
        initC = isHori ? clientX : clientY
    }
    function handleMove(event) {
        event.preventDefault()
        if (!dragable) return
        const { clientX, clientY } = isTouch ? event.touches[0] : event
        const distanceC = (isHori ? clientX : clientY) - initC + lastC
        moveC = distanceC
        disC = distanceC - lastC
        const trans = isHori ? `translate3d(${moveC}px,0,0)` : `translate3d(0,${moveC}px,0)`
        setTransform(node.style, trans)
    }
    function handleUp(event) {
        initC = moveC
        dragable = false
        let time = 0.3
        const delta = moveC + index * itemSize
        let i = index;
        if (delta < 0 && Math.abs(delta) >= safeC) { //向左滑动
            i++
        } else if (delta > 0 && Math.abs(delta) >= safeC) {
            i--
        }
        moveC = i * -1 * itemSize
        scroll2Target(moveC, time)
        if (autoplay) {
            auto()
        }
    }

    function transitionEnd(e) {
        if (e.propertyName === 'transform') {
            setTransition(node.style, '')
            index = Math.ceil(Math.abs(lastC) / itemSize)
            //判断边界
            if (index === 0) {
                index = _len - 2
            } else if (index === _len - 1) {
                index = 1
            }
            lastC = index * itemSize * -1
            const trans = isHori ? `translate3d(${(0 - index) * itemSize}px,0,0)` : `translate3d(0,${(0 - index) * itemSize}px,0)`
            setTransform(node.style, trans)
            node.dispatchEvent(
                new CustomEvent('dragend', {
                    detail: { index }
                })
            )
        }
    }

    function scroll2Target(y, time = 0.3) {
        setTransition(node.style, `cubic-bezier(0,0,0.2,1.15) ${time}s`)
        const trans = isHori ? `translate3d(${y}px,0,0)` : `translate3d(0,${y}px,0)`
        setTransform(node.style, trans)
        lastC = y
    }

    function auto() {
        if(_len === 1) return
        clearTimeout(timer)
        timer = setTimeout(() => {
            const time = 0.4
            let i = index;
            i++
            const y = i * itemSize * -1;
            setTransition(node.style, `cubic-bezier(0,0,0.2,1.15) ${time}s`)
            const trans = isHori ? `translate3d(${y}px,0,0)` : `translate3d(0,${y}px,0)`
            setTransform(node.style, trans)
            lastC = y
            auto()
        }, interval)
    }

    function stop() {
        timer && clearTimeout(timer);
    }
    //初始化是否自动播放
    if (autoplay) {
        auto()
    } else {
        stop()
    }
    //监听
    node.addEventListener('touchstart', handleDown)
    node.addEventListener('touchmove', handleMove)
    node.addEventListener('touchend', handleUp)
    node.addEventListener('touchcancel', handleUp)
    node.addEventListener('transitionend', transitionEnd)
    window.addEventListener('resize', init)
    //pc
    if (!isTouch) {
        node.addEventListener("mousedown", handleDown);
        node.addEventListener("mousemove", handleMove);
        node.addEventListener("mouseup", handleUp);
        node.addEventListener("mouseleave", handleUp);
    }

    return {
        update(params) {
            index = params.defaultIndex ? params.defaultIndex : index
        },
        destroy() {
            node.removeEventListener('touchstart', handleDown)
            node.removeEventListener('touchmove', handleMove)
            node.removeEventListener('touchend', handleUp)
            node.removeEventListener('touchcancel', handleUp)
            node.removeEventListener('transitionend', transitionEnd)
            window.removeEventListener('resize', init)
            if (!isTouch) {
                node.removeEventListener("mousedown", handleDown);
                node.removeEventListener("mousemove", handleMove);
                node.removeEventListener("mouseup", handleUp);
                node.removeEventListener("mouseleave", handleUp);
            }
            stop()
        }
    }
}
export function swipe(node, { len, activeIndex }) {
    //初始化变量
    let initY = 0
    let moveY = 0
    let lastY = 0
    let dragable = false
    let nodeH = 0
    let itemHeight = 50
    let index = activeIndex ? activeIndex : 1
    let _len = len
    let disX = 0
    //初始化
    setTimeout(init, 0)
    //初始化计算
    function init() {
        setTimeout(() => {
            nodeH = node.getBoundingClientRect().height
            itemHeight = nodeH / _len
            lastY = (1 - index) * itemHeight
            setTransform(node.style, `translate3d(0,${(1 - index) * itemHeight}px,0)`)
        }, 100)
    }
    //
    function px2vw(str) {
        return parseFloat(str) / 1 + 'px'
    }

    //鼠标按下或者手指按下，mousedown,touchstart
    function handleDown(event) {
        dragable = true
        const { clientY } = event.touches[0]
        initY = clientY
    }
    //移动，mousemove,touchmove
    function handleMove(event) {
        event.preventDefault()
        if (!dragable) return
        const { clientY } = event.touches[0]
        const distanceY = clientY - initY + lastY
        moveY = distanceY
        disX = distanceY - lastY
        setTransform(node.style, `translate3d(0,${px2vw(moveY)},0)`)
    }
    //鼠标或者手指放开
    function handleUp(event) {
        initY = moveY
        dragable = false
        let time = 0.3
        let height = (_len - 3) * itemHeight
        const { dis, duration } = velocity({
            num: disX,
            sizePercent: 1 / 2,
            coefficient: 4,
        })
        moveY = moveY + dis * itemHeight
        time = duration
        if (moveY % itemHeight !== 0) {
            moveY = Math.round(moveY / itemHeight) * itemHeight
        }
        if (moveY > 0) {
            moveY = 0
        } else if (Math.abs(moveY) > height) {
            moveY = height * -1
        }
        scroll2Target(moveY, time)
    }

    function scroll2Target(y, time = 0.3) {
        setTransition(node.style, `cubic-bezier(0,0,0.2,1.15) ${time}s`)
        setTransform(node.style, `translate3d(0,${px2vw(y)},0)`)
        lastY = y
    }
    //监听动画完成事件
    function transitionEnd(e) {
        if (e.propertyName === 'transform') {
            setTransition(node.style, '')
            index = Math.ceil(Math.abs(lastY) / itemHeight) + 1
            node.dispatchEvent(
                new CustomEvent('dragend', {
                    detail: { index }
                })
            )
        }
    }
    //监听
    node.addEventListener('touchstart', handleDown)
    node.addEventListener('touchmove', handleMove)
    node.addEventListener('touchend', handleUp)
    node.addEventListener('touchcancel', handleUp)
    node.addEventListener('transitionend', transitionEnd)
    window.addEventListener('resize', init)
    return {
        update(params) {
            _len = params.len
            index = params.activeIndex ? params.activeIndex : index
            setTimeout(init, 0)
        },
        destroy() {
            node.removeEventListener('touchstart', handleDown)
            node.removeEventListener('touchmove', handleMove)
            node.removeEventListener('touchend', handleUp)
            node.removeEventListener('touchcancel', handleUp)
            node.removeEventListener('transitionend', transitionEnd)
            window.removeEventListener('resize', init)
        }
    }
}


/*
    num：传入的拖拽的距离差
    coefficient：系数，-1~1 为基本值，系数默认为10
    dir：方向，默认为垂直
    sizePercent：当前屏幕宽度的比例，默认为1
*/
export function velocity({
    num,
    coefficient = 10,
    dir = "v",
    sizePercent = 1,
}) {
    let size = dir === "v" ? window.innerHeight : window.innerWidth;
    size = size * sizePercent;
    const maxV = 90;
    const control = size / maxV;
    const pi = Math.PI;
    const a = 1 / 180;
    const newNum = Math.min(num / control, 90);
    const dis = Math.round(Math.sin(pi * a * newNum) * coefficient);
    return {
        dis,
        duration: clamp(0.1, Math.abs(Math.sin(pi * a * newNum)), 0.6),
    };
}